import startCase from 'lodash/startCase';

export const formatBlogType = (type: string) => {
  switch (type) {
    case 'timeline_podcast':
      return 'Podcast';
    case 'timeline_article':
      return 'Article';
    default:
      return startCase(type);
  }
};
